import {cn} from 'platform/shared';

const CHOICE_CLASS_NAME = String.raw`[&_.eag--choice\_\_control:hover]:bg-[var(--color-palettes-white-10-100)] [&_.eag--choice\_\_control:focus-within]:!border-[var(--color-severity-informational)] [&_.eag--choice\_\_control:focus-within]:bg-[var(--color-palettes-white-10-100)] [&_.eag--choice\_\_control:focus-within]:![box-shadow:var(--shadow-active)]`;

// tw-migration accepted deviation: returns a Tailwind class string where the old lib returned a
// RuleSet<object> from the legacy CSS-in-JS library — the old return type IS the styling
// mechanism itself; a class string is the tw equivalent of "a bundle of styles to apply".
export const getChoiceCSS = (
  isInvalid?: boolean,
  isDisabled?: boolean,
  isRecommended?: boolean
) => {
  const shouldApplyRecommendedStyle = isRecommended && !isInvalid && !isDisabled;

  return cn(
    CHOICE_CLASS_NAME,
    isInvalid && String.raw`[&_.eag--choice\_\_control]:!border-[var(--color-severity-danger)]`,
    !isInvalid &&
      isDisabled &&
      String.raw`[&_.eag--choice\_\_control]:!border-[var(--color-palettes-neutral-70-40)]`,
    shouldApplyRecommendedStyle &&
      String.raw`[&_.eag--choice\_\_control]:bg-[var(--color-palettes-orange-10-100)]`
  );
};
